import { StateProvider } from '@uirouter/angularjs';

export default function ($stateProvider: StateProvider) {
  'ngInject';

  $stateProvider.state('noAuthOffers', {
    component: 'fizyPaycellNoAuthOffers',
    parent: 'noAuth',
    url: '/offers'
  });
}


// WEBPACK FOOTER //
// ./src/app/no-auth/offers/offers.routes.ts